import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const Header = styled.div`
  display: flex;
  padding: 10px 12px;
  border-bottom: 1px solid rgb(0 0 0 / 15%);
  align-items: center;
  justify-content: space-between;
`;

export const ActionsWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  justify-content: flex-end;
  padding: 0 12px 12px 0;
`;
export const StyledFormError = styled.div`
  text-align: right;
  background-color: #fff1f0;
  color: #f5222d;
  padding: 8px 24px;
`;
export const SubTitle = styled.div`
  font-size: 16px;
  font-weight: 500;
  padding: 16px;
`;
